import { UilClipboardAlt } from "@iconscout/react-unicons";
import { MdConnectWithoutContact, MdOutlineWaterDrop, MdWaves, MdOpacity, MdWaterDamage, MdWaterDrop, MdAir, MdGrass, MdApartment, MdLocalShipping } from "react-icons/md";
import { RiRedPacketLine } from "react-icons/ri";
import { GiTap, GiChemicalDrop, GiWaterRecycling } from "react-icons/gi";
// Analytics Cards imports
import { FaSignal, FaTemperatureHigh, FaFlask, FaTint, FaWater } from 'react-icons/fa';
import { WiRaindrop } from "react-icons/wi";
// Air Quality Details imports
import { WiHumidity } from "react-icons/wi";
import { GiWindSlap } from "react-icons/gi";
import { IoIosSpeedometer } from "react-icons/io";
import { TbWind } from "react-icons/tb";

// Solution Types Configuration
export const solutionTypes = [
  { id: 'stp',      name: 'STP',      fullName: 'Sewage Treatment Plant',   icon: GiWaterRecycling, color: '#8b5cf6', route: '/dashboard/stp' },
  { id: 'aqm',      name: 'AQM',      fullName: 'Air Quality Monitoring',   icon: MdAir,            color: '#10b981', route: '/dashboard/aqm' },
  { id: 'irrigation',name:'Irrigation',fullName: 'Irrigation System',       icon: MdGrass,          color: '#f59e0b', route: '/dashboard/irrigation' },
  { id: 'water',      name: 'Water',    fullName: 'Water Management',         icon: MdWaterDrop,      color: '#3b82f6', route: '/dashboard/water' },
  { id: 'facility', name: 'Facility', fullName: 'Facility Management',      icon: MdApartment,      color: '#667eea', route: '/dashboard/facility' },
  { id: 'fleet',    name: 'Fleet',    fullName: 'Fleet Management',          icon: MdLocalShipping,  color: '#f97316', route: '/dashboard/fleet' },
];

// Configured Solutions (can be fetched from API in future)
export const configuredSolutions = [
  { id: 'stp-1',      type: 'stp',      name: 'STP Dashboard',      isDefault: true },
  { id: 'aqm-1',      type: 'aqm',      name: 'AQM Dashboard',      isDefault: false },
  { id: 'irrigation-1',type:'irrigation',name: 'Irrigation Dashboard',isDefault: false },
  { id: 'facility-1', type: 'facility', name: 'Facility Dashboard', isDefault: false },
  { id: 'fleet-1',    type: 'fleet',    name: 'Fleet Dashboard',    isDefault: false },
  { id: 'water-1',   type: 'water',    name: 'Water Dashboard',    isDefault: false },
];

// Helper function to get solution type info
export const getSolutionTypeInfo = (typeId) => {
  return solutionTypes.find(t => t.id === typeId);
};

// Analytics Cards Data
export const cardsData = [
  {
    title: "GSM 1",
    id :'gsm1',
    color: {
      backGround: "linear-gradient(180deg, #bb67ff 0%, #c484f3 100%)",
      boxShadow: "0px 10px 20px 0px #e0c6f5",
    },
    barValue: 80,
    value: "Signal Strength",
    png: FaSignal,
    series: [
      {
        name: "GSM",
        data: [31, 40, 28, 51, 42, 109, 100],
      },
    ],
  },
  {
    title: "GSM 2",
    id:'gsm2',
    color: {
      backGround: "linear-gradient(180deg, #a0627d 0%, #a0629c 100%)",
      boxShadow: "0px 10px 20px 0px #e0c6f5",
    },
    barValue: 70,
    value: "Signal Strength",
    png: FaSignal,
    series: [
      {
        name: "GSM",
        data: [31, 40, 28, 51, 42, 109, 100],
      },
      ],
  },
  {
    title: "LoRa",
    id:'lora_ack',
    color: {
      backGround: "linear-gradient(180deg, #3d85c6 0%, #6fa8dc 100%)",
      boxShadow: "0px 10px 20px 0px #cfe2f3",
    },
    barValue: 80,
    value: "Packet Ack",
    png: RiRedPacketLine,
    series: [
      {
        name: "LoRa",
        data: [10, 100, 50, 70, 80, 30, 40],
      },
    ],
  },
  {
    title: "MQTT",
    id:'mqtt',
    color: {
      backGround:
        "linear-gradient(#996633 -146.42%, #cc9966 -46.42%)",
      boxShadow: "0px 10px 20px 0px #f9f2ec",
    },
    barValue: 90,
    value: "Commited Msg",
    png: UilClipboardAlt,
    series: [
      {
        name: "MQTT",
        data: [10, 25, 15, 30, 12, 15, 20],
      },
    ],
  },
  {
    title: "OMS",
    id:'reachable',
    color: {
      backGround:
        "linear-gradient(#14884e -146.42%, #39a78e -46.42%)",
      boxShadow: "0px 10px 20px 0px #e6ffee ",
    },
    barValue: 100,
    value: "Reachable",
    png: MdConnectWithoutContact,
    series: [
      {
        name: "MQTT",
        data: [10, 25, 15, 30, 12, 15, 20],
      },
    ],
  },
  /*{
    title: "Battery",
    color: {
      backGround:
        "linear-gradient(#355886 -150%, #294cbe -30%)",
      boxShadow: "0px 10px 20px 0px #cceeff",
    },
    barValue: 100,
    value: "Charge",
    png: UilClipboardAlt,
    series: [
      {
        name: "MQTT",
        data: [10, 25, 15, 30, 12, 15, 20],
      },
    ],
  },*/
];

export const solenoidData = [
  {
    title: "Solenoid 1",
    color: {
      backGround: "linear-gradient(180deg, #bb67ff 0%, #c484f3 100%)",
      boxShadow: "0px 10px 30px 0px #e0c6f5",
    },
       png: GiTap,
  },
  {
    title: "Solenoid 2",
    color: {
      backGround: "linear-gradient(180deg, #a0627d 0%, #a0629c 100%)",
      boxShadow: "0px 10px 20px 0px #e0c6f5",
    },
    png: GiTap,
  },
  {
    title: "Solenoid 3",
    color: {
      backGround: "linear-gradient(180deg, #FF919D 0%, #FC929D 100%)",
      boxShadow: "0px 10px 20px 0px #FDC0C7",
    },
    png: GiTap,
  },
  {
    title: "Solenoid 4",
    color: {
      backGround:
        "linear-gradient(#996633 -146.42%, #cc9966 -46.42%)",
      boxShadow: "0px 10px 20px 0px #f9f2ec",
    },
    png: GiTap,
  },
  {
    title: "Solenoid 5",
    color: {
      backGround:
        "linear-gradient(#14884e -146.42%, #39a78e -46.42%)",
      boxShadow: "0px 10px 20px 0px #e6ffee ",
    },
    png: GiTap,
  },
  {
    title: "Solenoid 6",
    color: {
      backGround:
        "linear-gradient(#355886 -150%, #294cbe -30%)",
      boxShadow: "0px 10px 20px 0px #cceeff",
    },
    png: GiTap,
  },
  {
    title: "Solenoid 7",
    color: {
      backGround:
        "linear-gradient(#b3b3b3 -150%, #b3b3b3 -50%)",
      boxShadow: "0px 10px 20px 0px #ffffff",
    },
    png: GiTap,
  },
  {
    title: "Solenoid 8",
    color: {
      backGround:
        "linear-gradient(#58417c -150%, #a693c5 -30%)",
      boxShadow: "0px 10px 20px 0px #cceeff",
    },
    png: GiTap,
  },
];

// Treated Water Parameters
export const waterQualityParams = [
  {
    name: "pH Level",
    icon: MdWaves,
    value: 7.2,
    unit: "pH",
    status: "Excellent"
  },
  {
    name: "TDS",
    icon: MdOutlineWaterDrop,
    value: 145,
    unit: "ppm",
    status: "Good"
  },
  {
    name: "Turbidity",
    icon: MdWaves,
    value: 2.1,
    unit: "NTU",
    status: "Good"
  },
  {
    name: "Chlorine",
    icon: FaFlask,
    value: 0.8,
    unit: "mg/L",
    status: "Excellent"
  },
  {
    name: "DO Level",
    icon: MdOutlineWaterDrop,
    value: 6.5,
    unit: "mg/L",
    status: "Good"
  },
  {
    name: "Temperature",
    icon: FaTemperatureHigh,
    value: 24.3,
    unit: "°C",
    status: "Excellent"
  }
];

// STP Process Stages
export const stpParams = [
  {
    name: "Collection Sumps",
    icon: MdWaves,
    value: "3/4",
    unit: "Pumps Active",
    status: "Good"
  },
  {
    name: "Receiving Stage",
    icon: MdWaves,
    value: "Online",
    unit: "Gravity Flow",
    status: "Excellent"
  },
  {
    name: "MBBR Reactor",
    icon: FaFlask,
    value: "Active",
    unit: "Aeration ON",
    status: "Excellent"
  },
  {
    name: "Tube Settler",
    icon: MdOutlineWaterDrop,
    value: "Normal",
    unit: "Settling",
    status: "Good"
  },
  {
    name: "Chlorination",
    icon: FaFlask,
    value: "0.8",
    unit: "mg/L Cl₂",
    status: "Excellent"
  },
  {
    name: "Filter Feed",
    icon: MdWaves,
    value: "2/2",
    unit: "Pumps Active",
    status: "Good"
  },
  {
    name: "Treated Sump",
    icon: MdOutlineWaterDrop,
    value: "85",
    unit: "% Capacity",
    status: "Good"
  },
  {
    name: "Sludge Handling",
    icon: FaFlask,
    value: "1/2",
    unit: "Pumps Active",
    status: "Good"
  }
];

// Dummy OMS Devices
export const dummyOMSDevices = [
  {
    name: "Gateway-001",
    signal: 95,
    battery: 85,
    status: "Online",
    lastUpdate: new Date().toLocaleString()
  },
  {
    name: "Sensor-Node-01",
    signal: 78,
    battery: 92,
    status: "Online",
    lastUpdate: new Date().toLocaleString()
  },
  {
    name: "Control-Unit-A",
    signal: 0,
    battery: 0,
    status: "Offline",
    lastUpdate: new Date(Date.now() - 3600000).toLocaleString()
  },
  {
    name: "Meter-Device-12",
    signal: 88,
    battery: 76,
    status: "Online",
    lastUpdate: new Date().toLocaleString()
  }
];

// Dummy Air Quality Devices
export const dummyAirQualityDevices = [
  {
    deviceId: "aq-001",
    name: "Air Quality Station - Main Building",
    status: "Online",
    aqi: 42,
    temperature: 28.5,
    humidity: 65,
    pm25: 12,
    lastUpdate: new Date().toLocaleString()
  },
  {
    deviceId: "aq-002",
    name: "Air Quality Station - Parking Area",
    status: "Online",
    aqi: 85,
    temperature: 32.1,
    humidity: 58,
    pm25: 35,
    lastUpdate: new Date().toLocaleString()
  },
  {
    deviceId: "aq-003",
    name: "Air Quality Station - Factory Zone",
    status: "Offline",
    aqi: 125,
    temperature: 29.8,
    humidity: 70,
    pm25: 68,
    lastUpdate: new Date(Date.now() - 3600000).toLocaleString()
  },
  {
    deviceId: "aq-004",
    name: "Air Quality Station - Garden Area",
    status: "Online",
    aqi: 28,
    temperature: 26.3,
    humidity: 72,
    pm25: 8,
    lastUpdate: new Date().toLocaleString()
  }
];

// Dummy Device List (for DeviceList page) - with hierarchical structure
export const dummyDeviceList = [
  {
    oms_id: "gw-001",
    name: "Gateway-001",
    type: "LoRa Gateway",
    connectivity: "LoRa",
    status: "Online",
    lastUpdate: new Date().toLocaleString(),
    childDevices: [
      {
        oms_id: "sensor-node-01",
        name: "Water Level Sensor 1",
        type: "Water Level",
        connectivity: "LoRa",
        status: "Online",
        lastUpdate: new Date().toLocaleString()
      },
      {
        oms_id: "sensor-node-02",
        name: "Water Level Sensor 2",
        type: "Water Level",
        connectivity: "LoRa",
        status: "Online",
        lastUpdate: new Date().toLocaleString()
      },
      {
        oms_id: "sensor-node-03",
        name: "Water Level Sensor 3",
        type: "Water Level",
        connectivity: "LoRa",
        status: "Offline",
        lastUpdate: new Date(Date.now() - 3600000).toLocaleString()
      },
      {
        oms_id: "aq-002",
        name: "Air Quality Monitor 2",
        type: "AQM",
        connectivity: "LoRa",
        status: "Online",
        lastUpdate: new Date().toLocaleString()
      }
    ]
  },
  {
    oms_id: "gw-002",
    name: "Gateway-002",
    type: "LoRa Gateway",
    connectivity: "LoRa",
    status: "Online",
    lastUpdate: new Date().toLocaleString(),
    childDevices: [
      {
        oms_id: "ctrl-001",
        name: "Control Unit A",
        type: "Contro Unit",
        connectivity: "LoRa",
        status: "Online",
        lastUpdate: new Date().toLocaleString()
      },
      {
        oms_id: "demo-004",
        name: "Meter Device 12",
        type: "Flow Meter",
        connectivity: "LoRa",
        status: "Online",
        lastUpdate: new Date().toLocaleString()
      }
    ]
  },
  {
    oms_id: "aq-001",
    name: "Air Quality Monitor 1",
    type: "AQM",
    connectivity: "WiFi",
    status: "Online",
    lastUpdate: new Date().toLocaleString()
  },
  {
    oms_id: "tw-001",
    name: "Treated Water Station 1",
    type: "Treated Water",
    connectivity: "WiFi",
    status: "Online",
    lastUpdate: new Date().toLocaleString()
  },
  {
    oms_id: "irr-001",
    name: "Irrigation Control Unit 1",
    type: "Irrigation",
    connectivity: "LoRa",
    status: "Online",
    lastUpdate: new Date().toLocaleString()
  }
];

// Air Quality Parameters (for AirQualityDetails page)
export const airQualityParameters = [
  {
    name: "Air Quality Index",
    icon: GiWindSlap,
    key: "aqi",
    unit: "AQI",
    threshold: 500
  },
  {
    name: "Temperature",
    icon: FaTemperatureHigh,
    key: "temperature",
    unit: "°C",
    threshold: 50
  },
  {
    name: "Humidity",
    icon: WiHumidity,
    key: "humidity",
    unit: "%",
    threshold: 100
  },
  {
    name: "Noise Level",
    icon: IoIosSpeedometer,
    key: "noise",
    unit: "dB",
    threshold: 120
  },
  {
    name: "PM1",
    icon: MdOutlineWaterDrop,
    key: "pm1",
    unit: "μg/m³",
    threshold: 100
  },
  {
    name: "PM2.5",
    icon: MdOutlineWaterDrop,
    key: "pm25",
    unit: "μg/m³",
    threshold: 250
  },
  {
    name: "PM10",
    icon: MdOutlineWaterDrop,
    key: "pm10",
    unit: "μg/m³",
    threshold: 500
  },
  {
    name: "Carbon Dioxide (CO₂)",
    icon: FaFlask,
    key: "co2",
    unit: "ppm",
    threshold: 5000
  },
  {
    name: "Sulphur Dioxide (SO₂)",
    icon: FaFlask,
    key: "so2",
    unit: "ppb",
    threshold: 500
  },
  {
    name: "Nitrogen Dioxide (NO₂)",
    icon: FaFlask,
    key: "no2",
    unit: "ppb",
    threshold: 400
  },
  {
    name: "Ozone (O₃)",
    icon: TbWind,
    key: "o3",
    unit: "ppb",
    threshold: 300
  },
  {
    name: "Carbon Monoxide (CO)",
    icon: FaFlask,
    key: "co",
    unit: "ppm",
    threshold: 50
  },
  {
    name: "Hydrogen Sulphide (H₂S)",
    icon: FaFlask,
    key: "h2s",
    unit: "ppb",
    threshold: 100
  },
  {
    name: "Ammonia (NH₃)",
    icon: FaFlask,
    key: "nh3",
    unit: "ppb",
    threshold: 500
  }
];

// Generate dummy air quality detail data based on deviceId
export const generateDummyAirQualityDetails = (deviceId) => {
  const baseData = {
    "aq-001": { aqi: 42, temp: 28.5, status: "Online" },
    "aq-002": { aqi: 85, temp: 32.1, status: "Online" },
    "aq-003": { aqi: 125, temp: 29.8, status: "Offline" },
    "aq-004": { aqi: 28, temp: 26.3, status: "Online" }
  };

  const device = baseData[deviceId] || { aqi: 50, temp: 27, status: "Online" };

  return {
    name: `Air Quality Station - ${deviceId.toUpperCase()}`,
    status: device.status,
    lastUpdate: new Date().toLocaleString(),
    aqi: device.aqi,
    temperature: device.temp,
    humidity: 60 + Math.random() * 20,
    noise: 45 + Math.random() * 30,
    pm1: Math.floor(device.aqi * 0.3),
    pm25: Math.floor(device.aqi * 0.4),
    pm10: Math.floor(device.aqi * 0.6),
    co2: 400 + Math.random() * 200,
    so2: 10 + Math.random() * 40,
    no2: 15 + Math.random() * 35,
    o3: 20 + Math.random() * 60,
    co: 0.5 + Math.random() * 2,
    h2s: 5 + Math.random() * 15,
    nh3: 10 + Math.random() * 30
  };
};

// Generate dummy historical AQI data for the last 30 days
export const generateDummyHistoricalData = (deviceId, days = 30) => {
  const historicalData = [];
  const now = new Date();

  const baseData = {
    "aq-001": { baseAqi: 42, basetemp: 28.5 },
    "aq-002": { baseAqi: 85, basetemp: 32.1 },
    "aq-003": { baseAqi: 125, basetemp: 29.8 },
    "aq-004": { baseAqi: 28, basetemp: 26.3 }
  };

  const device = baseData[deviceId] || { baseAqi: 50, basetemp: 27 };

  for (let i = days - 1; i >= 0; i--) {
    const date = new Date(now);
    date.setDate(date.getDate() - i);

    // Generate 4 readings per day (every 6 hours)
    for (let hour of [0, 6, 12, 18]) {
      const timestamp = new Date(date);
      timestamp.setHours(hour, Math.floor(Math.random() * 60), 0, 0);

      const aqiVariation = (Math.random() - 0.5) * 40;
      const tempVariation = (Math.random() - 0.5) * 6;
      const currentAqi = Math.max(0, device.baseAqi + aqiVariation);

      historicalData.push({
        timestamp: timestamp.toISOString(),
        aqi: Math.floor(currentAqi),
        temperature: parseFloat((device.basetemp + tempVariation).toFixed(1)),
        humidity: parseFloat((60 + Math.random() * 20).toFixed(1)),
        noise: Math.floor(45 + Math.random() * 30),
        pm1: Math.floor(currentAqi * 0.3),
        pm25: Math.floor(currentAqi * 0.4),
        pm10: Math.floor(currentAqi * 0.6),
        co2: Math.floor(400 + Math.random() * 200),
        so2: parseFloat((10 + Math.random() * 40).toFixed(1)),
        no2: parseFloat((15 + Math.random() * 35).toFixed(1)),
        o3: parseFloat((20 + Math.random() * 60).toFixed(1)),
        co: parseFloat((0.5 + Math.random() * 2).toFixed(2)),
        h2s: parseFloat((5 + Math.random() * 15).toFixed(1)),
        nh3: parseFloat((10 + Math.random() * 30).toFixed(1))
      });
    }
  }

  return historicalData.reverse(); // Most recent first
};

// Treated Water Parameters (for TreatedWaterDetails page)
export const treatedWaterParameters = [
  {
    name: "pH Level",
    icon: MdWaves,
    key: "ph",
    unit: "pH",
    threshold: 14
  },
  {
    name: "TDS",
    icon: MdOutlineWaterDrop,
    key: "tds",
    unit: "ppm",
    threshold: 500
  },
  {
    name: "Turbidity",
    icon: MdOpacity,
    key: "turbidity",
    unit: "NTU",
    threshold: 10
  },
  {
    name: "Temperature",
    icon: FaTemperatureHigh,
    key: "temperature",
    unit: "°C",
    threshold: 50
  },
  {
    name: "Dissolved Oxygen",
    icon: WiRaindrop,
    key: "dissolvedOxygen",
    unit: "mg/L",
    threshold: 15
  },
  {
    name: "Chlorine",
    icon: GiChemicalDrop,
    key: "chlorine",
    unit: "mg/L",
    threshold: 5
  },
  {
    name: "BOD",
    icon: FaFlask,
    key: "bod",
    unit: "mg/L",
    threshold: 30
  },
  {
    name: "COD",
    icon: FaFlask,
    key: "cod",
    unit: "mg/L",
    threshold: 250
  },
  {
    name: "Ammonia",
    icon: GiChemicalDrop,
    key: "ammonia",
    unit: "mg/L",
    threshold: 50
  },
  {
    name: "Nitrate",
    icon: FaTint,
    key: "nitrate",
    unit: "mg/L",
    threshold: 50
  },
  {
    name: "Flow Rate",
    icon: MdWaterDamage,
    key: "flowRate",
    unit: "L/min",
    threshold: 1000
  }
];

// Generate dummy treated water detail data based on deviceId
export const generateDummyTreatedWaterDetails = (deviceId) => {
  const baseData = {
    "tw-001": { ph: 7.2, temp: 25.5, status: "Online" },
    "tw-002": { ph: 7.5, temp: 26.3, status: "Online" },
    "tw-003": { ph: 6.8, temp: 24.8, status: "Offline" },
    "tw-004": { ph: 7.0, temp: 25.0, status: "Online" }
  };

  const device = baseData[deviceId] || { ph: 7.2, temp: 25, status: "Online" };

  return {
    name: `Treated Water Station - ${deviceId.toUpperCase()}`,
    status: device.status,
    lastUpdate: new Date().toLocaleString(),
    ph: device.ph,
    tds: 145 + Math.random() * 50,
    turbidity: 2 + Math.random() * 3,
    temperature: device.temp,
    dissolvedOxygen: 6 + Math.random() * 3,
    chlorine: 1.5 + Math.random() * 1,
    bod: 5 + Math.random() * 10,
    cod: 30 + Math.random() * 50,
    ammonia: 1 + Math.random() * 5,
    nitrate: 10 + Math.random() * 15,
    flowRate: 500 + Math.random() * 300
  };
};

// Generate dummy historical treated water data for the last 30 days
export const generateDummyTreatedWaterHistory = (deviceId, days = 30) => {
  const historicalData = [];
  const now = new Date();

  const baseData = {
    "tw-001": { basePh: 7.2, baseTemp: 25.5 },
    "tw-002": { basePh: 7.5, baseTemp: 26.3 },
    "tw-003": { basePh: 6.8, baseTemp: 24.8 },
    "tw-004": { basePh: 7.0, baseTemp: 25.0 }
  };

  const device = baseData[deviceId] || { basePh: 7.2, baseTemp: 25 };

  for (let i = days - 1; i >= 0; i--) {
    const date = new Date(now);
    date.setDate(date.getDate() - i);

    // Generate 4 readings per day (every 6 hours)
    for (let hour of [0, 6, 12, 18]) {
      const timestamp = new Date(date);
      timestamp.setHours(hour, Math.floor(Math.random() * 60), 0, 0);

      const phVariation = (Math.random() - 0.5) * 1;
      const tempVariation = (Math.random() - 0.5) * 4;

      historicalData.push({
        timestamp: timestamp.toISOString(),
        ph: parseFloat((device.basePh + phVariation).toFixed(2)),
        tds: parseFloat((145 + Math.random() * 50).toFixed(1)),
        turbidity: parseFloat((2 + Math.random() * 3).toFixed(2)),
        temperature: parseFloat((device.baseTemp + tempVariation).toFixed(1)),
        dissolvedOxygen: parseFloat((6 + Math.random() * 3).toFixed(2)),
        chlorine: parseFloat((1.5 + Math.random() * 1).toFixed(2)),
        bod: parseFloat((5 + Math.random() * 10).toFixed(1)),
        cod: parseFloat((30 + Math.random() * 50).toFixed(1)),
        ammonia: parseFloat((1 + Math.random() * 5).toFixed(2)),
        nitrate: parseFloat((10 + Math.random() * 15).toFixed(1)),
        flowRate: parseFloat((500 + Math.random() * 300).toFixed(1))
      });
    }
  }

  return historicalData.reverse(); // Most recent first
};

// Generate dummy water level detail data based on deviceId
export const generateDummyWaterLevelDetails = (deviceId) => {
  const baseData = {
    "sensor-node-01": { waterLevel: 75, motorStatus: "ON", battery: 85, gatewayName: "Gateway-001", gatewayId: "GW-001" },
    "sensor-node-02": { waterLevel: 45, motorStatus: "OFF", battery: 92, gatewayName: "Gateway-002", gatewayId: "GW-002" },
    "sensor-node-03": { waterLevel: 90, motorStatus: "OFF", battery: 78, gatewayName: "Gateway-001", gatewayId: "GW-001" },
  };

  const device = baseData[deviceId] || { waterLevel: 65, motorStatus: "OFF", battery: 80, gatewayName: "Gateway-001", gatewayId: "GW-001" };

  return {
    name: `Water Level Sensor - ${deviceId.toUpperCase()}`,
    status: "Online",
    lastUpdate: new Date().toLocaleString(),
    waterLevel: device.waterLevel,
    motorStatus: device.motorStatus,
    loraSignal: -75 + Math.floor(Math.random() * 20),
    battery: device.battery,
    gatewayName: device.gatewayName,
    gatewayId: device.gatewayId,
    tankCapacity: 5000
  };
};

// Generate dummy water level historical data for the last 30 days
export const generateDummyWaterLevelHistory = (deviceId, days = 30) => {
  const historicalData = [];
  const now = new Date();

  const baseData = {
    "sensor-node-01": { baseLevel: 75, motorOnProbability: 0.3 },
    "sensor-node-02": { baseLevel: 45, motorOnProbability: 0.5 },
    "sensor-node-03": { baseLevel: 90, motorOnProbability: 0.1 },
  };

  const device = baseData[deviceId] || { baseLevel: 65, motorOnProbability: 0.3 };

  for (let i = days - 1; i >= 0; i--) {
    const date = new Date(now);
    date.setDate(date.getDate() - i);

    // Generate 4 readings per day (every 6 hours)
    for (let hour of [0, 6, 12, 18]) {
      const timestamp = new Date(date);
      timestamp.setHours(hour, Math.floor(Math.random() * 60), 0, 0);

      const levelVariation = (Math.random() - 0.5) * 30;
      const waterLevel = Math.max(0, Math.min(100, device.baseLevel + levelVariation));
      const motorStatus = Math.random() < device.motorOnProbability ? "ON" : "OFF";

      historicalData.push({
        timestamp: timestamp.toISOString(),
        waterLevel: parseFloat(waterLevel.toFixed(1)),
        motorStatus: motorStatus,
        loraSignal: -75 + Math.floor(Math.random() * 20),
        battery: parseFloat((85 - (i / days) * 5 + Math.random() * 3).toFixed(1))
      });
    }
  }

  return historicalData.reverse(); // Most recent first
};

// LoRa Gateway Details
export const generateDummyLoraGatewayDetails = (gatewayId) => {
  return {
    gatewayId: gatewayId,
    name: `LoRa Gateway ${gatewayId}`,
    status: "Online",
    version: "v2.1.4",
    wifiSignal: -52,
    battery: 98,
    loraFrequency: 915,
    uptime: "45d 12h 30m",
    lastUpdate: new Date().toLocaleString()
  };
};

// LoRa Gateway Attached Devices
export const generateDummyLoraGatewayDevices = (gatewayId) => {
  return [
    {
      device_id: "sensor-node-01",
      name: "Water Level Sensor 1",
      type: "Water Level",
      status: "Online",
      rxSignal: -78,
      txSignal: -82,
      lastUpdate: new Date().toLocaleString()
    },
    {
      device_id: "sensor-node-02",
      name: "Water Level Sensor 2",
      type: "Water Level",
      status: "Online",
      rxSignal: -82,
      txSignal: -85,
      lastUpdate: new Date(Date.now() - 300000).toLocaleString()
    },
    {
      device_id: "sensor-node-03",
      name: "Water Level Sensor 3",
      type: "Water Level",
      status: "Offline",
      rxSignal: -110,
      txSignal: -115,
      lastUpdate: new Date(Date.now() - 3600000).toLocaleString()
    },
    {
      device_id: "aq-001",
      name: "Air Quality Monitor 1",
      type: "AQM",
      status: "Online",
      rxSignal: -65,
      txSignal: -68,
      lastUpdate: new Date().toLocaleString()
    },
    {
      device_id: "aq-002",
      name: "Air Quality Monitor 2",
      type: "AQM",
      status: "Online",
      rxSignal: -71,
      txSignal: -74,
      lastUpdate: new Date(Date.now() - 600000).toLocaleString()
    },
    {
      device_id: "fm-001",
      name: "Flow Meter 1",
      type: "Flow Meter",
      status: "Online",
      rxSignal: -88,
      txSignal: -91,
      lastUpdate: new Date(Date.now() - 120000).toLocaleString()
    },
    {
      device_id: "fm-002",
      name: "Flow Meter 2",
      type: "Flow Meter",
      status: "Online",
      rxSignal: -92,
      txSignal: -95,
      lastUpdate: new Date(Date.now() - 180000).toLocaleString()
    },
    {
      device_id: "ctrl-001",
      name: "Control Unit 1",
      type: "Control Unit",
      status: "Online",
      rxSignal: -75,
      txSignal: -78,
      lastUpdate: new Date().toLocaleString()
    }
  ];
};

// Dummy Notification Data
export const dummyNotifications = [
  {
    id: "notif-001",
    device_id: "sensor-node-01",
    device_name: "Water Level Sensor 1",
    type: "Alert",
    severity: "High",
    message: "Water level exceeded threshold - 95%",
    timestamp: new Date(Date.now() - 300000).toLocaleString(),
    status: "Unread"
  },
  {
    id: "notif-002",
    device_id: "aq-002",
    device_name: "Air Quality Station - Office",
    type: "Warning",
    severity: "Medium",
    message: "PM2.5 levels above normal - 48 μg/m³",
    timestamp: new Date(Date.now() - 600000).toLocaleString(),
    status: "Read"
  },
  {
    id: "notif-003",
    device_id: "gw-001",
    device_name: "Gateway-001",
    type: "Info",
    severity: "Low",
    message: "Gateway firmware update available",
    timestamp: new Date(Date.now() - 1800000).toLocaleString(),
    status: "Read"
  },
  {
    id: "notif-004",
    device_id: "tw-002",
    device_name: "Treated Water Sensor 2",
    type: "Alert",
    severity: "High",
    message: "pH level critically low - 5.2",
    timestamp: new Date(Date.now() - 180000).toLocaleString(),
    status: "Unread"
  },
  {
    id: "notif-005",
    device_id: "sensor-node-03",
    device_name: "Water Level Sensor 3",
    type: "Warning",
    severity: "Medium",
    message: "Battery level low - 15%",
    timestamp: new Date(Date.now() - 3600000).toLocaleString(),
    status: "Read"
  },
  {
    id: "notif-006",
    device_id: "aq-003",
    device_name: "Air Quality Station - Factory Zone",
    type: "Alert",
    severity: "High",
    message: "Device offline for 2 hours",
    timestamp: new Date(Date.now() - 7200000).toLocaleString(),
    status: "Unread"
  },
  {
    id: "notif-007",
    device_id: "fm-001",
    device_name: "Flow Meter 1",
    type: "Info",
    severity: "Low",
    message: "Maintenance due in 7 days",
    timestamp: new Date(Date.now() - 86400000).toLocaleString(),
    status: "Read"
  },
  {
    id: "notif-008",
    device_id: "ctrl-001",
    device_name: "Control Unit 1",
    type: "Warning",
    severity: "Medium",
    message: "Communication delay detected - 5s",
    timestamp: new Date(Date.now() - 900000).toLocaleString(),
    status: "Read"
  },
  {
    id: "notif-009",
    device_id: "tw-001",
    device_name: "Treated Water Sensor 1",
    type: "Alert",
    severity: "High",
    message: "Turbidity level exceeded - 12 NTU",
    timestamp: new Date(Date.now() - 1200000).toLocaleString(),
    status: "Unread"
  },
  {
    id: "notif-010",
    device_id: "sensor-node-02",
    device_name: "Water Level Sensor 2",
    type: "Info",
    severity: "Low",
    message: "Sensor calibration successful",
    timestamp: new Date(Date.now() - 172800000).toLocaleString(),
    status: "Read"
  }
];

// Control Unit Details Data
export const generateDummyControlUnitDetails = (deviceId) => {
  return {
    deviceId: deviceId,
    name: `Control Unit ${deviceId}`,
    status: "Online",
    version: "v2.1.5",
    lastUpdate: new Date().toLocaleString(),
    loraGateway: "GW-001",
    loraRx: -68,
    loraTx: -71,
    battery: 87,
    uptime: "15 days 8 hours",

    // Water tanks data
    tanks: [
      {
        id: 1,
        name: "Tank 1 - Primary Storage",
        currentLevel: 75,
        capacity: 10000,
        unit: "L",
        status: "Normal",
        lastFilled: new Date(Date.now() - 3600000 * 2).toLocaleString(),
      },
      {
        id: 2,
        name: "Tank 2 - Secondary Storage",
        currentLevel: 45,
        capacity: 8000,
        unit: "L",
        status: "Low",
        lastFilled: new Date(Date.now() - 3600000 * 5).toLocaleString(),
      },
      {
        id: 3,
        name: "Tank 3 - Reserve Tank",
        currentLevel: 90,
        capacity: 5000,
        unit: "L",
        status: "Normal",
        lastFilled: new Date(Date.now() - 3600000 * 1).toLocaleString(),
      },
      {
        id: 4,
        name: "Tank 4 - Emergency Tank",
        currentLevel: 30,
        capacity: 3000,
        unit: "L",
        status: "Critical",
        lastFilled: new Date(Date.now() - 3600000 * 12).toLocaleString(),
      }
    ],

    // Motors data
    motors: [
      {
        id: 1,
        name: "Motor 1 - Main Pump",
        status: "Running",
        power: "1.5 HP",
        current: 8.5,
        voltage: 240,
        runtime: "2h 15m",
        lastStarted: new Date(Date.now() - 3600000 * 2.25).toLocaleString(),
      },
      {
        id: 2,
        name: "Motor 2 - Backup Pump",
        status: "Off",
        power: "1.5 HP",
        current: 0,
        voltage: 240,
        runtime: "0h 0m",
        lastStarted: new Date(Date.now() - 3600000 * 8).toLocaleString(),
      },
      {
        id: 3,
        name: "Motor 3 - Transfer Pump",
        status: "Running",
        power: "1.0 HP",
        current: 5.2,
        voltage: 240,
        runtime: "1h 30m",
        lastStarted: new Date(Date.now() - 3600000 * 1.5).toLocaleString(),
      },
      {
        id: 4,
        name: "Motor 4 - Circulation Pump",
        status: "Off",
        power: "0.5 HP",
        current: 0,
        voltage: 240,
        runtime: "0h 0m",
        lastStarted: new Date(Date.now() - 3600000 * 6).toLocaleString(),
      },
      {
        id: 5,
        name: "Motor 5 - Drain Pump",
        status: "Off",
        power: "0.75 HP",
        current: 0,
        voltage: 240,
        runtime: "0h 0m",
        lastStarted: new Date(Date.now() - 3600000 * 24).toLocaleString(),
      }
    ]
  };
};

// Control Unit History Data
export const generateDummyControlUnitHistory = (deviceId) => {
  const history = [];
  const now = Date.now();

  // Generate last 50 history events
  for (let i = 0; i < 50; i++) {
    const timestamp = new Date(now - i * 600000 - Math.random() * 300000); // Events every ~10 min with variation
    const eventTypes = ['water_level', 'motor_on', 'motor_off', 'lora_signal'];
    const eventType = eventTypes[Math.floor(Math.random() * eventTypes.length)];

    let event = {
      id: `evt-${i + 1}`,
      timestamp: timestamp.toLocaleString(),
      loraRx: -65 - Math.floor(Math.random() * 15),
      loraTx: -68 - Math.floor(Math.random() * 15),
    };

    switch (eventType) {
      case 'water_level':
        event.eventType = 'Water Level';
        event.tankId = Math.floor(Math.random() * 4) + 1;
        event.tankName = `Tank ${event.tankId}`;
        event.level = Math.floor(Math.random() * 100);
        event.message = `Tank ${event.tankId} level: ${event.level}%`;
        event.icon = '💧';
        break;
      case 'motor_on':
        event.eventType = 'Motor ON';
        event.motorId = Math.floor(Math.random() * 5) + 1;
        event.motorName = `Motor ${event.motorId}`;
        event.message = `Motor ${event.motorId} started`;
        event.icon = '▶️';
        break;
      case 'motor_off':
        event.eventType = 'Motor OFF';
        event.motorId = Math.floor(Math.random() * 5) + 1;
        event.motorName = `Motor ${event.motorId}`;
        event.message = `Motor ${event.motorId} stopped`;
        event.icon = '⏸️';
        break;
      case 'lora_signal':
        event.eventType = 'LoRa Signal';
        event.message = `Signal update - RX: ${event.loraRx} dBm, TX: ${event.loraTx} dBm`;
        event.icon = '📡';
        break;
      default:
        break;
    }

    history.push(event);
  }

  return history;
};

// Irrigation Control Unit Details Data
export const generateDummyIrrigationDetails = (deviceId) => {
  return {
    deviceId: deviceId,
    name: `Irrigation Unit ${deviceId}`,
    status: "Online",
    version: "v1.2.3",
    lastUpdate: new Date().toLocaleString(),
    loraGateway: "GW-001",
    loraRx: -72,
    loraTx: -75,
    battery: 92,
    uptime: "12 days 5 hours",

    // Flow meters data
    flowMeters: [
      {
        id: 1,
        name: "Flow Meter 1 - Main Line",
        status: "Active",
        currentFlow: 12.5,
        totalFlow: 15680.5,
        todayFlow: 845.2,
        lastReading: new Date().toLocaleString()
      },
      {
        id: 2,
        name: "Flow Meter 2 - Secondary Line",
        status: "Active",
        currentFlow: 8.3,
        totalFlow: 9250.8,
        todayFlow: 520.6,
        lastReading: new Date().toLocaleString()
      }
    ],

    // Pressure meters data
    pressureMeters: [
      {
        id: 1,
        name: "Pressure Meter 1",
        location: "Main Line Inlet",
        status: "Normal",
        currentPressure: 4.2,
        minPressure: 3.8,
        maxPressure: 4.5,
        unit: "bar",
        lastReading: new Date().toLocaleString()
      },
      {
        id: 2,
        name: "Pressure Meter 2",
        location: "Zone A Distribution",
        status: "Normal",
        currentPressure: 3.5,
        minPressure: 3.2,
        maxPressure: 3.8,
        unit: "bar",
        lastReading: new Date().toLocaleString()
      },
      {
        id: 3,
        name: "Pressure Meter 3",
        location: "Zone B Distribution",
        status: "Low",
        currentPressure: 2.1,
        minPressure: 1.8,
        maxPressure: 2.5,
        unit: "bar",
        lastReading: new Date().toLocaleString()
      },
      {
        id: 4,
        name: "Pressure Meter 4",
        location: "Secondary Line Outlet",
        status: "Normal",
        currentPressure: 3.8,
        minPressure: 3.5,
        maxPressure: 4.0,
        unit: "bar",
        lastReading: new Date().toLocaleString()
      }
    ],

    // Solenoids data (8 solenoids)
    solenoids: [
      {
        id: 1,
        name: "Solenoid 1",
        zone: "Zone A - North Garden",
        status: "Open",
        runtime: "1h 15m",
        cycles: 128,
        lastActivated: new Date(Date.now() - 3600000 * 1.25).toLocaleString()
      },
      {
        id: 2,
        name: "Solenoid 2",
        zone: "Zone A - South Garden",
        status: "Closed",
        runtime: "0h 0m",
        cycles: 95,
        lastActivated: new Date(Date.now() - 3600000 * 4).toLocaleString()
      },
      {
        id: 3,
        name: "Solenoid 3",
        zone: "Zone B - Front Lawn",
        status: "Open",
        runtime: "0h 45m",
        cycles: 112,
        lastActivated: new Date(Date.now() - 3600000 * 0.75).toLocaleString()
      },
      {
        id: 4,
        name: "Solenoid 4",
        zone: "Zone B - Back Lawn",
        status: "Closed",
        runtime: "0h 0m",
        cycles: 88,
        lastActivated: new Date(Date.now() - 3600000 * 6).toLocaleString()
      },
      {
        id: 5,
        name: "Solenoid 5",
        zone: "Zone C - Vegetable Garden",
        status: "Closed",
        runtime: "0h 0m",
        cycles: 156,
        lastActivated: new Date(Date.now() - 3600000 * 3).toLocaleString()
      },
      {
        id: 6,
        name: "Solenoid 6",
        zone: "Zone C - Herb Garden",
        status: "Closed",
        runtime: "0h 0m",
        cycles: 78,
        lastActivated: new Date(Date.now() - 3600000 * 8).toLocaleString()
      },
      {
        id: 7,
        name: "Solenoid 7",
        zone: "Zone D - Flower Beds",
        status: "Closed",
        runtime: "0h 0m",
        cycles: 64,
        lastActivated: new Date(Date.now() - 3600000 * 12).toLocaleString()
      },
      {
        id: 8,
        name: "Solenoid 8",
        zone: "Zone D - Shrubs",
        status: "Closed",
        runtime: "0h 0m",
        cycles: 45,
        lastActivated: new Date(Date.now() - 3600000 * 10).toLocaleString()
      }
    ]
  };
};

// Irrigation LoRa Gateways Data
export const dummyIrrigationLoraGateways = [
  {
    gatewayId: "lora-gw-001",
    name: "LoRa Gateway - North Zone",
    status: "Online",
    loraFrequency: "915 MHz",
    wifiSignal: -52,
    uptime: "45d 12h 30m",
    lastUpdate: new Date().toLocaleString(),
    controlUnits: [
      {
        deviceId: "irr-cu-001",
        name: "Irrigation Unit - Garden A",
        status: "Online",
        zones: 4,
        activeZones: 2,
        loraRx: -68,
        lastUpdate: new Date().toLocaleString()
      },
      {
        deviceId: "irr-cu-002",
        name: "Irrigation Unit - Garden B",
        status: "Online",
        zones: 3,
        activeZones: 1,
        loraRx: -72,
        lastUpdate: new Date().toLocaleString()
      },
      {
        deviceId: "irr-cu-003",
        name: "Irrigation Unit - Lawn Area",
        status: "Offline",
        zones: 6,
        activeZones: 0,
        loraRx: -95,
        lastUpdate: new Date(Date.now() - 3600000).toLocaleString()
      }
    ]
  },
  {
    gatewayId: "lora-gw-002",
    name: "LoRa Gateway - South Zone",
    status: "Online",
    loraFrequency: "915 MHz",
    wifiSignal: -48,
    uptime: "30d 8h 15m",
    lastUpdate: new Date().toLocaleString(),
    controlUnits: [
      {
        deviceId: "irr-cu-004",
        name: "Irrigation Unit - Vegetable Garden",
        status: "Online",
        zones: 8,
        activeZones: 3,
        loraRx: -65,
        lastUpdate: new Date().toLocaleString()
      },
      {
        deviceId: "irr-cu-005",
        name: "Irrigation Unit - Flower Beds",
        status: "Online",
        zones: 5,
        activeZones: 2,
        loraRx: -70,
        lastUpdate: new Date().toLocaleString()
      }
    ]
  },
  {
    gatewayId: "lora-gw-003",
    name: "LoRa Gateway - East Zone",
    status: "Offline",
    loraFrequency: "915 MHz",
    wifiSignal: -85,
    uptime: "0d 0h 0m",
    lastUpdate: new Date(Date.now() - 7200000).toLocaleString(),
    controlUnits: [
      {
        deviceId: "irr-cu-006",
        name: "Irrigation Unit - Park Area",
        status: "Offline",
        zones: 4,
        activeZones: 0,
        loraRx: -110,
        lastUpdate: new Date(Date.now() - 7200000).toLocaleString()
      }
    ]
  }
];

// Irrigation History Data
export const generateDummyIrrigationHistory = (deviceId) => {
  const history = [];
  const now = Date.now();

  // Generate last 50 history events
  for (let i = 0; i < 50; i++) {
    const timestamp = new Date(now - i * 600000 - Math.random() * 300000);
    const eventTypes = ['solenoid_open', 'solenoid_close', 'flow_update', 'lora_signal'];
    const eventType = eventTypes[Math.floor(Math.random() * eventTypes.length)];

    let event = {
      id: `evt-${i + 1}`,
      timestamp: timestamp.toLocaleString(),
      loraRx: -65 - Math.floor(Math.random() * 15),
      loraTx: -68 - Math.floor(Math.random() * 15),
    };

    switch (eventType) {
      case 'solenoid_open':
        event.eventType = 'Solenoid Open';
        event.solenoidId = Math.floor(Math.random() * 8) + 1;
        event.message = `Solenoid ${event.solenoidId} opened`;
        event.icon = '🚿';
        break;
      case 'solenoid_close':
        event.eventType = 'Solenoid Close';
        event.solenoidId = Math.floor(Math.random() * 8) + 1;
        event.message = `Solenoid ${event.solenoidId} closed`;
        event.icon = '🔒';
        break;
      case 'flow_update':
        event.eventType = 'Flow Update';
        event.flowMeterId = Math.floor(Math.random() * 2) + 1;
        event.flowRate = (5 + Math.random() * 15).toFixed(1);
        event.message = `Flow Meter ${event.flowMeterId}: ${event.flowRate} L/min`;
        event.icon = '💧';
        break;
      case 'lora_signal':
        event.eventType = 'LoRa Signal';
        event.message = `Signal update - RX: ${event.loraRx} dBm, TX: ${event.loraTx} dBm`;
        event.icon = '📡';
        break;
      default:
        break;
    }

    history.push(event);
  }

  return history;
};
